import InfoRoundedIcon from '@mui/icons-material/InfoRounded';
import IconButton from '@mui/material/IconButton';
import Tooltip, { type TooltipProps } from '@mui/material/Tooltip';

type TooltipIconProps = Omit<TooltipProps, 'children'>;

export const TooltipIcon = ({ ...props }: TooltipIconProps) => (
  <Tooltip {...props}>
    <IconButton size="small">
      <InfoRoundedIcon />
    </IconButton>
  </Tooltip>
);
